import { Box, Button, SxProps } from "@outschool/backpack";
import React from "react";

interface Props {
  tabs: {
    label: string;
    value: string;
  }[];
  selectedTab: string;
  onChange: (value: string) => void;
  sx?: SxProps;
}

const ClassListTabs = ({ tabs, selectedTab, onChange, sx }: Props) => {
  return (
    <Box flex sx={{ gap: "2.2rem", justifyContent: "center", ...sx }}>
      {tabs.map(tab => (
        <Button
          key={tab.value}
          onClick={() => onChange(tab.value)}
          variant="text"
          sx={{
            padding: "0.8rem",
            color: selectedTab === tab.value ? "text.primary" : "text.disabled",
            fontSize: "2.2rem",
            fontWeight: 700,
            lineHeight: 1.2,
            backgroundColor: "transparent !important"
          }}
        >
          {tab.label}
        </Button>
      ))}
    </Box>
  );
};

export default ClassListTabs;
